import { CrudService, httpClient, type HttpClient } from '../core'
import { usersEndpoints } from './users.endpoints'
import { userPageSchema, userSchema, type UserCreateBody, type UserDto, type UserFilters, type UserUpdateBody } from './users.schemas'

/** list, listAll, get, create, update and remove come from `CrudService`; add resource-specific calls here. */
export class UsersService extends CrudService<UserDto, UserCreateBody, UserUpdateBody, UserFilters> {
  constructor(http: HttpClient = httpClient) {
    super(http, usersEndpoints, { item: userSchema, page: userPageSchema })
  }
}

export const usersService = new UsersService()
